import'quickdom';import plus from'./plus.js';var remove = plus.extend({
  options: {
    style: {
      transform: 'rotate(45deg)'
    }
  }
});export default remove;